// extracted by mini-css-extract-plugin
export default {"description":"MyAccount_description__jDIAX"};